module.exports = __webpack_public_path__ + "img/email-icon.15a1d687.png";